import React from 'react'
import CardKeyValue from '../../../../../card/cardKeyValue';
import TextNotAssigned from '../../../../../text/TextNotAssigned';

const BasicInformation = ({ detail }) => (
  <div className='flex flex-nowrap gap-4 pb-2 items-strech justify-center overflow-auto'>
    { detail.code &&
      <CardKeyValue
        className='min-w-100px max-w-150px'
        title='Code'
        value={detail.code || ''}
      />
    }
    { detail.name &&
      <CardKeyValue 
        className='min-w-100px max-w-150px'
        title='Name'
        value={detail.name || ''}
      /> 
    }
    <CardKeyValue 
      className='min-w-100px max-w-150px'
      title='Year level'
      value={detail.yearLevel?.map((year) => year?.name || year?._id || year).join(', ') || ''}
    /> 
    { detail?.curriculumElements?.elementId && 
      <CardKeyValue 
        className='min-w-100px max-w-150px'
        title={detail?.curriculumElements?.elementId?.keyName}
        value={detail?.curriculumElements?.elementId?.valueName || detail?.curriculumElements?.elementId?.value} 
      /> 
    }
    { detail?.curriculumElements?.subElementId && 
      <CardKeyValue 
        className='min-w-100px max-w-150px'
        title={detail?.curriculumElements?.subElementId?.keyName}
        value={detail?.curriculumElements?.subElementId?.valueName || detail?.curriculumElements?.subElementId?.value} 
      /> 
    }
    { detail?.curriculumElements?.elementId &&
      <CardKeyValue 
        className='min-w-100px max-w-150px'
        title='Subject'
        value={detail?.subjectId?.name || <TextNotAssigned />}
      /> 
    }
  </div>
)

export default BasicInformation